module.exports = __webpack_public_path__ + "img/lu.b3da342e.svg";